import { type PostContentObjectDetail, createPostContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getPost } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const usePostQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<PostContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<PostContentObjectDetail>({
    async queryFn() {
      const { data } = await getPost({ routeParams: { id } });
      return createPostContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
